import "./SideBar.css"
function SideBarButton({text, onClick}) {
    return(
        <button className="side-bar-button" onClick={onClick}>{text}</button>
    )
}
export default SideBarButton;